import { render } from "./DotStyle.vue?vue&type=template&id=cd728d68"
import script from "./DotStyle.vue?vue&type=script&lang=ts"
export * from "./DotStyle.vue?vue&type=script&lang=ts"
script.render = render

export default script